import axios from "axios";
import {apiURL, makeFormData} from "src/utilities/utilityFunctions";
import {appSettingModel} from "src/datamodels/foundation";

export const login = (data,callBack,Fail) => {
    let formDataStuff = makeFormData(data);
    axios.post(apiURL() + "/users/login",formDataStuff).then((evt)=>callBack(evt)).catch((evt)=>Fail(evt));
};

export const checkEmailUnique = (email,callBack,fail) => {
    axios.get(apiURL() + "/users/emailUnique/" + email,{headers:{
            "DomainCode":appSettingModel().domainCode
        }}).then((evt)=>callBack(evt)).catch((evt)=>fail(evt));
};
